<template>
  <div class="m-box">
    <img src="@/assets/img/home/facetop.png" alt="">
    <div class="m-nav">
      <div class="m-item" v-for="(item,index) in styleList" :key="index">
        <img :src="item.icoUrl" alt="">
        <p>{{item.text}}</p>
      </div>

    </div>
  </div>
</template>

<script>

  export default {
    components: {},
    data () {
      return {
        styleList:[
          {icoUrl:require('@/assets/img/home/face802.png'),text:'请确保手机前置摄像头可以正常使用'},
          {icoUrl:require('@/assets/img/home/face799.png'),text:'请确保对应的手机相机权限已授权'},
          {icoUrl:require('@/assets/img/home/face801.png'),text:'请正面正对摄像头，确保头像完全进入拍摄框内'},
          {icoUrl:require('@/assets/img/home/face800.png'),text:'注意灯光，避免强光直射面对造成照片模糊'}
        ]
      }
    },
    created () {

    },
    methods: {},
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  .m-box{
    margin-top: 70px;
    text-align: center;
    >img{
      width: 103px;
      height: 103px;
      margin-bottomn-:55px;
    }
    .m-nav{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 15px;
      .m-item{
        width: 140px;
        background: #FBFBFB;
        padding: 10px 5px;
        margin-top: 25px;
        >img{
          width: 30px;
          height: 30px;
          object-fit: contain;
          margin-bottom: 10px;
        }
        >p{
          font-size: 10px;
        }
      }
    }
  }
</style>

